// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1R1lM","col":"styles_col__m6Kb0","fulfillmentStatus":"styles_fulfillmentStatus__sqsTh","emailCol":"styles_emailCol__1yhOB"};